import { render, staticRenderFns } from "./TalentCreate.vue?vue&type=template&id=46cd9388"
import script from "./TalentCreate.vue?vue&type=script&lang=js"
export * from "./TalentCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports